'use client'

import { useMemo } from 'react'

export interface ChildBlock {
    type: string
    version: number
    children?: Array<ChildBlock>
    [k: string]: unknown
}

function flattenBlock(child: ChildBlock) {
    let combined = ''
    if (child.children) {
        for (const childBlock of child.children) {
            if (childBlock.children) {
                combined += childBlock.children.map((block) => flattenBlock(block)).join()
            }
            combined += childBlock.text || ''
        }
    }
    return combined
}

interface Props {
    heading?: ChildBlock | string
    defaultTitle?: string
}

/**
 * Flattens a heading block by removing links and returning a span with formatting applied
 */
export function FlatTitle({ heading, defaultTitle = '' }: Props) {
    const title = useMemo(() => {
        if (!heading) {
            return defaultTitle
        }

        if (typeof heading === 'string') {
            return heading
        }

        return flattenBlock(heading) || defaultTitle
    }, [heading, defaultTitle])

    // Note: This is a XSS vulnerability if an attacker was to manipulate the state data for rehydration
    return <span dangerouslySetInnerHTML={{ __html: title }} />
}
